import { ReactNode } from 'react';

import { HStack, Text, VStack } from '@vimeo/bokeh';

interface FeatureRowProps {
  title: string;
  description: string;
  Icon: ReactNode;
}

export function FeatureRow({ title, description, Icon }: FeatureRowProps) {
  return (
    <HStack alignItems="start" gap="md">
      {Icon}
      <VStack alignItems="start" gap="0">
        <Text variant="body-lg">{title}</Text>
        <Text variant="body-md" color="text-secondary">
          {description}
        </Text>
      </VStack>
    </HStack>
  );
}
